import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  addSupplierPublicInquiryAction,
  editSupplierPublicInquiryAction,
  getSupplierPublicInquiryAction,
} from '../../../../modules/inquiries/suppliers/public/Actions';
import {
  inquiryByIdSelector,
  supplierPublicInquiriesIsLoadingSelector,
  PublicSupplierListSelector,
} from '../../../../modules/inquiries/suppliers/public/Selectors';

import { getSuppliersAction } from '../../../../modules/suppliers/Actions';
import { suppliersAsLabelAndValueSelector } from '../../../../modules/suppliers/Selectors';

import { getSupplierCategoriesAction } from '../../../../modules/supplierCategories/Actions';
import {
  supplierCategoriesAsValueAndLabel,
  supplierCategoriesAsLabelAndValueSelector,
} from '../../../../modules/supplierCategories/Selectors';
import { suppliersProductsAsLabelAndValueSelector } from '../../../../modules/supplierProducts/Selectors';

import {
  InputField,
  TextArea,
  Select,
  SearchableSelect,
  FormSectionTitle,
  Upload,
} from '../../../../components/form';
import * as Yup from 'yup';
import Form from '../../../../components/form/FormGroup';
import { customerDataSelector } from '../../../../modules/auth/Selectors';
import Card from '../../../../components/UI/Card/Card';
import Spearator from '../../../../components/form/Misc/Separator';
import getLangData from '../../../../utils/getLangData';
import { lang } from 'moment';
// import ModerationForm from '../../../../components/form/ModerationForm';

const schema = () =>
  Yup.object().shape({
    title: Yup.string()
      .required(getLangData().fields.required)
      .default('')
      .max(140),
    // .default('').test('len', 'Must be exactly 140 characters', val => val.length === 5),
    supplierCID: Yup.string()
      .required(getLangData().fields.required)
      .default(''),
    message: Yup.string()
      .default('')
      .required(getLangData().fields.required)
      .default(''),
    attachment: Yup.string().default(''),
  });

const ViewPublicInquiry = (props) => {
  const {
    isLoading,
    pendingIsLoading,

    inquiryID,

    inquiry,
    getPublicInquiry,
    moderateCreateSupplierPublicInquiry,
    getArtisans,
    getSupplierCategories,
    supplierCategories,

    supplier,
    addPublicIquiry,
    editPublicInquiry,
    customerData,
  } = props;
  const lang = getLangData().fields

  // for testing only
  const customerId = customerData._id;
  const { trusted } = customerData
  console.log('trust', trusted);
  const mappedCID = supplierCategories.map((el) => {
    return {
      value: el._id,
      label: el.name,
    };
  });
  useEffect(() => {
    // getArtisans();
    // getSupplierProducts();
    getSupplierCategories();
    console.log(inquiryID);
    if (inquiryID !== 'create') {
      getPublicInquiry(inquiryID);
    }
    console.log(inquiryID);
  }, [inquiryID, getPublicInquiry]);

  return (
    <Formik
      enableReinitialize
      validationSchema={schema()}
      initialValues={inquiry ? { ...inquiry } : schema().cast()}
      onSubmit={(values) => {
        console.log(values);
        const data = {
          supplierCID: inquiry ? values.supplierCID[0] : values.supplierCID._id,
          title: values.title,
          message: values.message,
          attachment: values.attachment,
          customerId,
        };
        if (inquiryID === 'create') {
          // console.log(data)
          addPublicIquiry(data, trusted);
        } else {
          editPublicInquiry('', { publicSupplierInquiryID: inquiryID, ...data }, trusted);
        }
      }}
    >
      {({ values, handleSubmit, setFieldValue, errors }) => {
        return (
          <Form
            handleSubmit={handleSubmit}
            heading={lang.supplier_public_inquiry}
            isLoading={isLoading || pendingIsLoading}
            errors={errors}
          >
            {console.log(values)}
            <InputField name="title" label={lang.title} />
            {/* <InputField name='supplierDetail.businessName' label='Supplier Name' /> */}
            {/* <Select
              label="Supplier"
              name="supplierId"
              // value={supplier.filter(
              //   (object) => values.country.indexOf(object.value) > -1
              // )}
              options={supplier}
              onChange={(value) => {
                setFieldValue('supplierId', value.value);

                console.log('chaned');
              }}
            /> */}
            {/* <InputField name='aproductId.name' label='Product Name' /> */}
            <SearchableSelect
              label={lang.categore}
              name={inquiry ? 'supplierCategoryData.[0]' : 'supplierCID'}
              // value="supplierCategoryData.name"
              // value={values.supplierCID.filter(
              //   (object) => values.aproductId.indexOf((object.value) > -1)
              // )}
              // inArray={true}
              disabled={inquiry ? true : false}
              options={supplierCategories}
              getItems={getSupplierCategories}
            // onChange={(value) => {
            // 	setFieldValue("aproductName", value.label);
            // 	console.log("we changed or something");
            // }}
            />
            {/* <TextArea
              name="aproductId.description"
              label="Product Description"
            /> */}
            <TextArea name="message" label={lang.message} />
            <Upload
              data={{ userID: customerId }}
              name="attachment"
              label={`${lang.inquiry_image} :`}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />
            <Spearator />

            <FormSectionTitle>{lang.proposal}</FormSectionTitle>
            {inquiry?.proposals.length > 0 ? (
              inquiry.proposals.map((el) => (
                <>
                  {/* <p>{el.message}</p>
								<p>{el.price}</p> */}
                  <Card
                    attach={el.attachment}
                    logo={el?.supplierData?.logo}
                    message={el.message}
                    price={el.price}
                    name={el?.supplierData?.businessName}
                    phone={el?.supplierData?.contactPersonPhone}
                    address={el?.supplierData?.contactPersonEmail}
                  />
                  {/* <Card message={el.message} price={el.price} name={el.supplierData.businessName} /> */}
                </>
              ))
            ) : (
              <p>{getLangData().general_words.no_proposals_yet}</p>
            )}
            {/* <InputField name="qtyRequired" label="Quantity Required" /> */}
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: inquiryByIdSelector(state, inquiryID),
    isLoading: supplierPublicInquiriesIsLoadingSelector(state),
    supplier: suppliersAsLabelAndValueSelector(state),
    supplierCategories: supplierCategoriesAsLabelAndValueSelector(state),
    customerData: customerDataSelector(state),
  };
};

const mapDispatchToProps = {
  getPublicInquiry: getSupplierPublicInquiryAction,
  getArtisans: getSuppliersAction,
  getSupplierCategories: getSupplierCategoriesAction,
  editPublicInquiry: editSupplierPublicInquiryAction,
  addPublicIquiry: addSupplierPublicInquiryAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPublicInquiry);
